import { render, staticRenderFns } from "./CardActualite.vue?vue&type=template&id=5ef5b664&scoped=true&"
import script from "./CardActualite.vue?vue&type=script&lang=js&"
export * from "./CardActualite.vue?vue&type=script&lang=js&"
import style0 from "./CardActualite.vue?vue&type=style&index=0&id=5ef5b664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5b664",
  null
  
)

export default component.exports